import { render, staticRenderFns } from "./ReportUserList.vue?vue&type=template&id=5fc4660a&scoped=true&"
import script from "./ReportUserList.vue?vue&type=script&lang=js&"
export * from "./ReportUserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc4660a",
  null
  
)

export default component.exports